import { Loader2 } from "lucide-react";

import { TOKENS as T } from "../styles/styles";

// First thing anyone sees. Carries the TuneWatch identity rather than a bare
// spinner — and adds no artificial delay: it only shows while auth/profile load.
export default function LoadingScreen({ loaderPageStyle }) {
  return (
    <div style={{ ...loaderPageStyle, ...splashStyle }}>
      <div style={markStyle}>
        <svg viewBox="0 0 512 512" width="40" height="40" aria-hidden="true">
          <path
            d="M212 178 L338 256 L212 334 Z"
            fill="#FFFFFF"
            stroke="#FFFFFF"
            strokeWidth="40"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <h1 style={wordmarkStyle}>TuneWatch</h1>
      <p style={taglineStyle}>Track what you love. Together.</p>

      <Loader2 size={20} className="spin" color={T.mutedForeground} />
    </div>
  );
}

const splashStyle = {
  flexDirection: "column",
  gap: 0,
};

const markStyle = {
  width: 72,
  height: 72,
  borderRadius: 22,
  background: T.primary,
  boxShadow: "0 10px 30px rgba(0,119,255,0.30)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const wordmarkStyle = {
  margin: "18px 0 0",
  fontSize: 24,
  fontWeight: 800,
  letterSpacing: "-0.01em",
  color: T.foreground,
};

const taglineStyle = {
  margin: "6px 0 28px",
  fontSize: 13,
  color: T.mutedForeground,
};
